export default {
  de: {
    notifications: {
      save: {
        type: 'success',
        message: 'Kommentar erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      }
    }
  }
}
